var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.722,
    height: 24,
    viewBox: "0 0 20.722 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exit",
    d: "M55.481,9.274,52.872,6.665a.7.7,0,1,0-.994.994l1.409,1.409H50.109V.7a.7.7,0,0,0-.7-.7H35.666a.7.7,0,0,0-.7.7V18.84a.7.7,0,0,0,.357.612L43.2,23.909A.7.7,0,0,0,44.25,23.3V19.543h5.156a.7.7,0,0,0,.7-.7V10.475h3.177l-1.409,1.409a.7.7,0,1,0,.994.994l2.609-2.609A.7.7,0,0,0,55.481,9.274ZM42.843,22.091,36.371,18.43V1.909L42.843,5.57ZM48.7,18.137H44.25V5.16a.7.7,0,0,0-.357-.612L38.339,1.406H48.7V9.068H47.062a.7.7,0,1,0,0,1.406H48.7Z",
    transform: "translate(-34.965)",
    fill: "#d00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d762623b867c21c886477d993d0cab5f.svg";
export { ForwardRef as ReactComponent };